export default __webpack_public_path__ + "static/media/revoq.90438848.png";